/* eslint-disable @typescript-eslint/no-explicit-any */
// services/ReadByUserIdService.ts
import {ReadByUserIdResponse} from "../model/response/ReadByUserIdResponse.ts";
import {BaseService} from "./BaseService.ts";

export class ReadByUserIdService {
    static create = (others: any, data: ReadByUserIdResponse) => {
        return BaseService.apiClient(others).post("/read-by-workspace-user-id/create", data);
    };

    static read = (others: any) => {
        return BaseService.apiClient(others).get<ReadByUserIdResponse>("/read-by-workspace-user-id/read");
    };
}
